import React from 'react'
import { string } from 'prop-types'

import { MenuItem } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function KeywordsInCategory({ keyword, categoryTitle }) {
  return (
    <li className="cgt-model-search__suggestion">
      <MenuItem label={`${keyword} in ${categoryTitle}`} fluid />
    </li>
  )
}

KeywordsInCategory.propTypes = {
  keyword: string.isRequired,
  categoryTitle: string.isRequired,
}

export default KeywordsInCategory
